<template>
  <div class="full-page" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <news-banner />
      <div
        class="page-header header-filter"
        :class="setPageClass"
      >
        <div class="container md-offset">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <!--<div class="container md-offset">-->
          <!--<nav>-->
          <!--<ul>-->
          <!--<li>-->
          <!--<router-link :to="{path:'/dashboard'}">Home</router-link>-->
          <!--</li>-->
          <!--<li>-->
          <!--<a href="#">-->
          <!--Company-->
          <!--</a>-->
          <!--</li>-->
          <!--<li>-->
          <!--<a href="#">-->
          <!--Portfolio-->
          <!--</a>-->
          <!--</li>-->
          <!--<li>-->
          <!--<a href="#">-->
          <!--Blog-->
          <!--</a>-->
          <!--</li>-->
          <!--</ul>-->
          <!--</nav>-->
          <div
            class="copyright text-center"
            >&copy; {{ new Date().getFullYear() }} e-Tax. All Rights Reserved.
            &nbsp;
            <a v-if="isPrivacyPolicyVisited" class="static-lnk" href="/privacy-policy">Privacy Policy</a>
          </div>
          <!--</div>-->
        </footer>

        <div class="sticky-note" v-if="!isPrivacyPolicyVisited">
          <p class="pop">We take your privacy seriously and only process your personal information to make your experience better. Using this platform indicates your consent with the processing of your data by eTax and its partners, as detailed in our <a class="pop-lnk static-lnk" href="/privacy-policy">Privacy Policy</a></p>
          <div class="ck-btn">
            <md-button slot="footer" class="md-sm mt-4 md-theme-default pull-right" @click="setCookie">Got it</md-button>
          </div>
        </div>

        <!-- New Calculator -->
        <tax-calculator-new  />
      </div>
    </div>
    <news-popup-v2 v-if="showNewsPopup" />
  </div>
</template>

<script>
import { ZoomCenterTransition } from "vue2-transitions";
import TaxCalculatorNew from "@/components/TaxCalculatorNew";
import NewsBanner from "@/components/News/NewsBanner.vue";
import NewsPopupV2 from "@/components/News/NewsPopupV2.vue";
import { getCookieByName, setCookieByName } from "@/lib/utils";

export default {
  components: {
    NewsBanner,
    NewsPopupV2,
    TaxCalculatorNew,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      responsive: false,
      showMenu: false,
      showCalculator: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
      privacyPolicyVisited: false,
      showNewsPopup: false
    };
  },
  computed: {
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },

    isPrivacyPolicyVisited() {
      return this.privacyPolicyVisited;
    }
  },
  methods: {
    setCookie() {
      const isCookieSet = setCookieByName('privacyPolicyVisited', 'true');
      if(isCookieSet) this.privacyPolicyVisited = true;
    },
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.privacyPolicyVisited = getCookieByName('privacyPolicyVisited');
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    if (this.$route && this.$route.fullPath === "/login") {
      this.showNewsPopup = true
    }
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  }
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
.copyright {
  width: 100%;
  text-align: center;
}

.footer-notification-pos {
  bottom: 0px;
}


.static-lnk {
  text-decoration: underline;
}
.sticky-note {
  align-items: flex-start;
  animation: php .5s cubic-bezier(.25,1,.5,1) .12s forwards;
  background: #fff;
  bottom: 1rem;
  box-shadow: 0 0.2rem 0.6rem #05162833;
  display: flex;
  flex-direction: column;
  max-width: 24rem;
  overflow: hidden;
  position: fixed;
  left: 1rem;
  width: calc(100vw - 2rem);
  z-index: 1000;
  text-align: justify !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  opacity: 0.8;
  border-radius: 4px;
}

.pop {
  color: #333;
}

.pop-lnk {
  color: #333 !important;
  font-weight: 500 !important;
}

.ck-btn {
  width:100%;
  margin-top: -1rem;
}

@media (min-width: 1024px) {
  .sticky-note {
    bottom: 3rem;
    left: 3rem;
  }
}

@media (min-width: 400px) {
  .sticky-note {
    bottom: 1.5rem;
    padding: 0.3rem;
    left: 1.5rem;
    width: calc(100vw - 3rem);
  }
}

/* MAIN BACKGROUND FIX */
.page-header.header-filter {
  background: #F5F5F5 !important;
  background-image: none !important;
}

/* Remove overlay layer (Material Dashboard adds this) */
.page-header.header-filter::before,
.page-header.header-filter::after {
  display: none !important;
}

/* Ensure full height + proper centering */
.page-header {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Container should not bring grey */
.page-header .container {
  background: transparent !important;
}
</style>
